import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// not like to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init
//const en = require('./assets/locales/translation.json')
const en_t = require('./assets/locales/translation_template.json')

const langs = {
  en: {
    name: 'English',
    translation: en_t
  }
}

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources: langs,
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    }
  });


export default i18n;
